// extracted by mini-css-extract-plugin
export default {"main_css_us":"SecondaryButton_main_css_us__ljzXb","main_css_jp":"SecondaryButton_main_css_jp__Qtqx4"};